var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "map",
    attrs: {
      id: _vm.mapId
    }
  }), _vm.type === "computed" ? _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_c("el-button", {
    attrs: {
      type: "text",
      size: "mini"
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("返回")]), _vm.data !== undefined ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("获取距离值")]) : _vm._e()], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };